import { TopolTemplateSettings } from "@/schemas/template/settingsSchema";

export const templateSettings: TopolTemplateSettings = {
  "h1:color": "#000000",
  "h1:font-family": "Helvetica, Arial, sans-serif",
  "h2:color": "#000000",
  "h2:font-family": "Helvetica, Arial, sans-serif",
  "h3:color": "#000000",
  "h3:font-family": "Helvetica, Arial, sans-serif",
  ":color": "#000000",
  ":font-family": "Helvetica, Arial, sans-serif",
  ":line-height": "1.5",
  "a:color": "#24bfbc",
  "button:background-color": "#e85034",
  containerWidth: 600,
  templateBackgroundColor: "#FFFFFF",
  fonts: "Helvetica,Arial,sans-serif",
  "mj-text": {
    "line-height": 1.5,
    "font-family": "Helvetica, Arial, sans-serif",
    padding: "15px",
  },
  "mj-button": {
    align: "center",
    "text-align": "center",
    "background-color": "#e85034",
    color: "#ffffff",
    "border-radius": "8px",
    "font-size": "13px",
    padding: "20px 20px 20px 20px",
    "inner-padding": "10px 20px 10px 20px",
    "font-family": "Helvetica, Arial, sans-serif",
    "font-weight": "normal",
    "font-style": "normal",
    "text-transform": "none",
    "text-decoration": "none",
  },
  "mj-carousel": {
    "icon-width": "44px",
    "tb-width": "110px",
    "tb-border-radius": "6px",
    padding: "10px 15px 10px 15px",
    "tb-hover-border-color": "#fead0d",
    "tb-selected-border-color": "#cacaca",
  },
  "mj-divider": {
    "border-color": "#000000",
    "border-style": "solid",
    "border-width": "1px",
    padding: "10px 10px",
    "padding-top": "10px",
    "padding-right": "10px",
  },
  "mj-spacer": {
    height: "50px",
  },
  "mj-gif": {
    padding: "0px",
    "fluid-on-mobile": "false",
    align: "center",
    "border-radius": "0px",
  },
  "mj-image": {
    padding: "0px",
    "fluid-on-mobile": "false",
    align: "center",
    "border-radius": "0px",
  },
  "mj-loop": {
    padding: "0px",
    "in-group": true,
  },
  "mj-social": {
    padding: "10px",
    "icon-size": "35px",
    "icon-padding": "0px",
    align: "center",
  },
  "mj-column": {
    "vertical-align": "top",
  },
  "mj-section": {
    "full-width": "full-width",
    padding: "10px 0px 10px 0px",
  },
  "mj-rating": {
    align: "center",
    padding: "10px 10px 10px 10px",
    questionAttributes: {
      color: "#1a1a1a",
      "font-size": "18px",
      "font-family": "Helvetica, Arial, sans-serif",
      "font-weight": "600",
      padding: "0px 0px 12px 0px",
    },
    captionsAttributes: {
      color: "#9a9a9a",
      "font-size": "12px",
      "font-family": "Helvetica, Arial, sans-serif",
      padding: "8px 0px 0px 0px",
      layout: "below",
      layoutMobile: "below",
    },
    segmentsAttributes: {
      size: "32px",
      gap: "4px",
      autoWidth: true,
      color: "#1a1a1a",
      "font-size": "14px",
      "font-family": "Helvetica, Arial, sans-serif",
      "background-color": "#ffffff",
      border: "1px #1a1a1a solid",
      "border-radius": "8px",
    },
    imageLabelAttributes: {
      color: "#1a1a1a",
      "font-size": "12px",
      "font-family": "Helvetica, Arial, sans-serif",
    },
  },
};
